import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { updateTask } from "../../api/todo.js";
import { TodoDataTestIds } from "../../constants/dataTestIds.js";
import { useAxiosProvider } from "../../providers/AxiosProvider.js";
import { useTodoListProvider } from "../../providers/TodoListProvider.js";
import { Status, Category } from "../../todo-list.types.js";
import { Comment } from "../Comment/Comment.js";
import { StatusMenu as StatusMenu$1, StatusOptions, OptionText } from "./StatusMenu.styles.js";
import "../../helpers/parseArrayQueryParam.js";
import "axios";
import "@mui/material";
import "date-fns";
import "../../constants/recallDelayTime.js";
import "../Comment/Comment.helpers.js";
import "react-hook-form";
import "@hookform/resolvers/yup";
import "yup";
import "../Comment/Comment.styles.js";
import "@mui/material/styles";
const StatusMenu = ({ todo: selectedTodo, anchorEl, onClose, onStatusChange }) => {
  var _a, _b, _c;
  const axios = useAxiosProvider();
  const [selectedOption, setSelectedOption] = useState(Status.TO_DO);
  const { labels } = useTodoListProvider();
  const { mutateAsync } = useMutation({
    mutationFn: (data) => updateTask(axios)(selectedTodo.referenceId, data)
  });
  const hideCommentField = () => {
    setSelectedOption(Status.TO_DO);
    onStatusChange();
  };
  const handleClose = () => {
    onClose();
    setSelectedOption(Status.TO_DO);
    onStatusChange();
  };
  const handleDone = () => {
    mutateAsync({ ...selectedTodo, status: Status.DONE }).then(handleClose);
  };
  const handleClick = (e) => {
    e.stopPropagation();
  };
  const handleStatusChange = (status) => () => {
    setSelectedOption(status);
    onStatusChange(status);
  };
  const showCommentField = selectedOption === Status.IGNORED || selectedOption === Status.RECALLED;
  if (!anchorEl)
    return null;
  return /* @__PURE__ */ jsxs(
    StatusMenu$1,
    {
      elevation: 1,
      "data-testid": TodoDataTestIds.TodoStatusMenu,
      id: "todo-status-menu",
      anchorEl,
      keepMounted: true,
      open: true,
      onClose: handleClose,
      onClick: handleClick,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      children: [
        !showCommentField && /* @__PURE__ */ jsxs("div", { children: [
          (selectedTodo == null ? void 0 : selectedTodo.category) === Category.FOLLOWUP_APPOINTMENT && /* @__PURE__ */ jsx(StatusOptions, { "data-testid": TodoDataTestIds.TodoStatusOptions, onClick: handleDone, children: /* @__PURE__ */ jsx(OptionText, { "data-testid": TodoDataTestIds.TodoStatusMenuOptionDone, variant: "Lato Overline Bold", children: (_a = labels == null ? void 0 : labels.comment) == null ? void 0 : _a.done }) }, "done-status-button"),
          /* @__PURE__ */ jsx(
            StatusOptions,
            {
              "data-testid": TodoDataTestIds.TodoStatusOptions,
              onClick: handleStatusChange(Status.IGNORED),
              children: /* @__PURE__ */ jsx(OptionText, { "data-testid": TodoDataTestIds.TodoStatusMenuOptionIgnore, variant: "Lato Overline Bold", children: (_b = labels == null ? void 0 : labels.comment) == null ? void 0 : _b.ignore })
            },
            "ignore-status-button"
          ),
          /* @__PURE__ */ jsx(
            StatusOptions,
            {
              "data-testid": TodoDataTestIds.TodoStatusOptions,
              onClick: handleStatusChange(Status.RECALLED),
              children: /* @__PURE__ */ jsx(OptionText, { "data-testid": TodoDataTestIds.TodoStatusMenuOptionRecall, variant: "Lato Overline Bold", children: (_c = labels == null ? void 0 : labels.comment) == null ? void 0 : _c.recall })
            },
            "recall-status-button"
          )
        ] }),
        showCommentField && /* @__PURE__ */ jsx(Comment, { onClose: hideCommentField, onSubmit: handleClose, status: selectedOption })
      ]
    }
  );
};
export {
  StatusMenu as default
};
